"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const faqs = [{
    question: "Какви са работните часове на Миш-Маш /интерпред/?",
    answer: "Заведението е отворено от понеделник до петък, от 08:00 до 16:00 часа. В събота и неделя предлагаме възможност за организиране на събития"
  }, {
    question: "Как мога да направя поръчка?",
    answer: "Можете да направите поръчка чрез контактната форма на нашия сайт. Просто попълнете формата с вашите предпочитания и ние ще се свържем с вас за потвърждение."
  }, {
    question: "Имате ли фиксирано меню?",
    answer: "Не, менюто ни се обновява всеки ден. Всяка сутрин качваме новото дневно меню на основната страница, така че винаги има нещо свежо и интересно за вас."
  }, {
    question: "Организирате ли частни и фирмени събития?",
    answer: "Да, предлагаме възможност за организиране на частни и фирмени събития в нашето заведение. За повече информация посетете страницата \"Събития\" или се свържете с нас директно."
  }, {
    question: "Къде се намирате?",
    answer: "Намираме се в ж.к. Бъкстон (Красно село), на бул. „Цар Борис III“ 159 – в сградата на Бизнес център Интерпред."
  }, {
    question: "Има ли опция за резервация на маса?",
    answer: "Да, можете да резервирате маса като ни се обадите на +359 888 007 342 или изпратите запитване чрез контактната форма."
  }];
  return <section id="често-задавани-въпроси" className="bg-background py-16 md:py-24" ref={ref}>
      <div className="container">
        <div className={`mx-auto max-w-3xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`}>
          <h2 className="mb-3 text-center text-foreground">
            Често задавани въпроси
          </h2>
          <p className="mb-12 text-center text-muted-foreground">
            Отговори на най-често задаваните въпроси за Миш-Маш /интерпред/.
          </p>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="card border-border bg-[hsl(0_0%_96%)] px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] data-[state=open]:bg-accent/10 data-[state=open]:shadow-clay-hover">
                <AccordionTrigger className="text-foreground hover:no-underline">
                  <span className="text-left font-semibold">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}